import { useRouter } from "next/router";

export const useRouterPath = () => {
  const { asPath, query } = useRouter();

  return {
    path: asPath.split("?")[0],
    query,
  };
};
